﻿import { resizeWidget, initialize, sendMessage } from "./application";
import { initValidation } from "./validation";
import '../components/job-salary.js';

(function handleFileComponents() {
  const submitBtn = document.querySelector("button[type='submit']");

  const fileUploadComponents = document.querySelectorAll('hh-file-upload');

  [].forEach.call(fileUploadComponents, (element) => {
      element.addEventListener('fileRemoved', event => {
          const inputName = event.detail.inputName;

          const fileNodes = document.querySelectorAll(`[id^='${inputName}']`);

          Array.from(fileNodes).forEach(fileInput => {
              fileInput.value = null;
          });
      });

      element.addEventListener('fileUploaded', event => {            
          const details = event.detail;

          // loop over keys in repsonse to set hidden inputs
          for (var key in details.response) {
              const value = details.response[key];
              const property = key[0].toUpperCase() + key.slice(1);
              let hiddenInput = document.getElementById(`${details.inputName}_${property}`);

              hiddenInput.value = value;
          }
          submitBtn.disabled = false;
      });
      // prevent default so we can get drop event
      element.addEventListener("dragover", function (event) {
          event.preventDefault();
      });

      element.addEventListener("disableForm", event => {          
          submitBtn.disabled = event.detail.disable;
      })
  });
}());


function ready(fn) {
  if (
    document.attachEvent
      ? document.readyState === "complete"
      : document.readyState !== "loading"
  ) {
    fn();
  } else {
    document.addEventListener("DOMContentLoaded", fn);
  }
}

if (window.attachEvent) {
  window.attachEvent("onload", resizeWidget);
} else {
  if (window.onload) {
    var curronload = window.onload;
    var newonload = function(evt) {
      curronload(evt);
      resizeWidget(evt);
    };
    window.onload = newonload;
  } else {
    window.onload = resizeWidget;
  }
}

(function() {
  if (typeof window.CustomEvent === "function") return false;

  function CustomEvent(event, params) {
    params = params || { bubbles: false, cancelable: false, detail: undefined };
    var evt = document.createEvent("CustomEvent");
    evt.initCustomEvent(
      event,
      params.bubbles,
      params.cancelable,
      params.detail
    );
    return evt;
  }

  CustomEvent.prototype = window.Event.prototype;

  window.CustomEvent = CustomEvent;
})();

Object.defineProperty(Element.prototype, "dataset", {
  get: function() {
    var element = this;
    var attributes = this.attributes;
    var map = {};

    for (var i = 0; i < attributes.length; i++) {
      var attribute = attributes[i];

      if (
        attribute &&
        attribute.name &&
        /^data-\w[\w\-]*$/.test(attribute.name)
      ) {
        var name = attribute.name;
        var value = attribute.value;

        var propName = name.substr(5).replace(/-./g, function(prop) {
          return prop.charAt(1).toUpperCase();
        });

        Object.defineProperty(map, propName, {
          enumerable: this.enumerable,
          get: function() {
            return this.value;
          }.bind({ value: value || "" }),
          set: function setter(name, value) {
            if (typeof value !== "undefined") {
              this.setAttribute(name, value);
            } else {
              this.removeAttribute(name);
            }
          }.bind(element, name)
        });
      }
    }

    return map;
  }
});

function addBackListener() {
    var backButton = document.querySelector('.back-link');

    if (backButton) {
        backButton.addEventListener('click', function (e) {
            var backUrl = e.currentTarget.href;
            backUrl = backUrl.toLowerCase();
            if (!(backUrl.indexOf("hirehive.com") >= 0 || backUrl.indexOf("localhost:44314") >= 0)) {
                e.preventDefault();
                sendMessage("goBackToList", null);
            }
        });
    }
}

function addResizeListener() {
    if (window.addEventListener) {
        window.addEventListener("resize", resizeWidget, false);
    } else if (window.attachEvent) {
        window.attachEvent("resize", resizeWidget);
    }
}

ready(initialize);
resizeWidget();
ready(resizeWidget);
setTimeout(resizeWidget, 5000);
ready(addBackListener);
ready(addResizeListener);

initValidation();

if (window.addEventListener) {
  window.addEventListener("hh-resize", resizeWidget, false);
} else if (window.attachEvent) {
  window.attachEvent("hh-resize", resizeWidget);
}

const resetFormIfNeeded = event => {
  if (window.__modelStateCount && window.__modelStateCount < 3) {      
      const applicationForm = document.querySelector('form[name="ApplicationForm"]');
      applicationForm.reset();
  }
};

window.addEventListener("pageshow", resetFormIfNeeded);
